import { Core } from "@faire/design-tokens";
import { Spacer } from "@faire/web/slate/spacing";
import { Span, Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import * as React from "react";

import { getSettingOwFImproveTermsTouchpointsPDP } from "@faire/retailer/settings/getSettingOwFImproveTermsTouchpointsPDP";

interface IProps {
  nonReturnableReason: string | undefined;
}

export const ProductFinalSale: React.FC<IProps> = ({ nonReturnableReason }) => {
  if (!nonReturnableReason) {
    return null;
  }

  return (
    <>
      <Spacer size="2x" />
      <Typography>
        {getSettingOwFImproveTermsTouchpointsPDP() ? (
          <>{nonReturnableReason}</>
        ) : (
          <StrictLocalMsg
            defaultMessage="<CriticalTextFormatting>Final sale.</CriticalTextFormatting> {nonReturnableReasonFullyTranslatedSentence}"
            values={{
              nonReturnableReasonFullyTranslatedSentence: nonReturnableReason,
              CriticalTextFormatting: CriticalTextFormatting,
            }}
            description={{
              text: "Reason of why this product is not returnable",
              img: "https://cdn.faire.com/fastly/a61b22c359fe1972f35652379bdb6b05c0a8b3d19fe7167199da3cdbe3ee5ca1.png",
            }}
          />
        )}
      </Typography>
    </>
  );
};

const CriticalTextFormatting = (chunks: JSX.Element) => (
  <Span color={Core.text.critical}>{chunks}</Span>
);
